import * as React from "react";
import { useEffect } from "react";
import { SignPageContainer } from "./SignPage.styled";
import { Container } from "../ContactPage/ContactPage.styled";
import { observer } from "mobx-react";
import { useStores } from "../../stores";
import { HEADER_TYPE } from "../../constants";
import { useLocation, useNavigate, useOutlet } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

interface SignPageProps {}

export const SignPage = observer(({}: SignPageProps) => {
	const { settingsStore, authStore } = useStores();
	const navigate = useNavigate();
	const location = useLocation();
	const outlet = useOutlet();

	useEffect(() => {
		settingsStore.setTypeHeader(HEADER_TYPE.RELATIVE);
	}, []);

	useEffect(() => {
		if (authStore.isAuth) {
			navigate("/cabinet/my-day");
		}
	}, [authStore.isAuth]);

	return (
		<>
			<SignPageContainer>
				<Container>
					<AnimatePresence mode="wait">
						<motion.div
							key={location.pathname}
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							transition={{
								duration: 0.25,
								ease: "easeOut",
							}}
						>
							{outlet}
						</motion.div>
					</AnimatePresence>
				</Container>
			</SignPageContainer>
		</>
	);
});
